import React from 'react';
import { Div, P } from '@kizi/core-components';
import { getRendererFromDescriptor } from '@kizi/comparator-core';

export const CrossSellingBlockWrapper = ({ descriptor, header }) => {
  const contentJsx = getRendererFromDescriptor(descriptor);

  return (
    <Div
      my={4}
      p={6}
      backgroundColor={'main.0'}
      borderRadius={2}
      css={{
        boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.15)',
      }}
    >
      <P
        mb="24px"
        variant="baseBodyImportant"
        textAlign={'start'}
        fontSize={['25px', '25px', '30px']}
        lineHeight={['25px', '25px', '45px']}
      >
        {header}
      </P>
      <Div
        css={{
          display: 'flex',
          gap: '20px',
          flexDirection: ['column', 'column', 'row'],
          flexWrap: 'wrap',
        }}
      >
        {contentJsx}
      </Div>
    </Div>
  );
};
